import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { convertMdToHtml } from '..'
import Interweave from 'interweave'
import Section from '../../Section'

const TestSuiteResults = ({ report: { reportContent } }) => (
  <Section title="Test Suite Results">
    <Fragment key={0}>
      {reportContent.breakdownAndAutomatedAnalysis.testSuiteText && (
        <Interweave
          content={convertMdToHtml.makeHtml(
            '\n' + reportContent.breakdownAndAutomatedAnalysis.testSuiteText + '\n',
          )}
        />
      )}
    </Fragment>
    <Fragment key={1}>
      {reportContent.breakdownAndAutomatedAnalysis.testSuiteData && (
        <Interweave
          content={convertMdToHtml.makeHtml(
            '```\n' + reportContent.breakdownAndAutomatedAnalysis.testSuiteData + '\n```',
          )}
        />
      )}
    </Fragment>
  </Section>
)

TestSuiteResults.propTypes = {
  report: PropTypes.object,
}

export default TestSuiteResults
